import { CoffeeOutlined } from '@ant-design/icons'
import React from 'react'

export const VOTING_TEXTS = {
  0: <CoffeeOutlined />,
  0.5: <span className="diagonal-fractions">1/2</span>,
}
